export const view_bids_table_header = [
	{ order: 1, key: "id", name: "Id", visibility: true },
	{ order: 2, key: "price", name: "Price", visibility: true },
	{ order: 3, key: "status", name: "Status", visibility: true },
	{ order: 4, key: "dealer_name", name: "Dealer Name", visibility: true },
];

export const bid_status_drop_options = [
    { label: "Select status...", value: "" },
	{ label: "Accepted", value: "accepted" },
	{ label: "Rejected", value: "rejected" },
];
